var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","padding":"0","margin":"0"}},[_c('router-view',{staticClass:"content_display_area"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }